import { render, staticRenderFns } from "./TextToAudio.vue.js?vue&type=template&id=2e82895c!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TextToAudio.vue?vue&type=template&id=2e82895c"
import script from "./TextToAudio.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TextToAudio.vue?vue&type=script&lang=js"
export * from "./TextToAudio.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TextToAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports